﻿import React from 'react';
import { Instance } from '../model/Instance';
import { Overview } from './Overview';
import { Invoices } from './Invoices';
import { CompanyInformation } from './CompanyInformation';

const InstanceNodes = ({ instance }: Props) => {
  return (
    <div className="nav-align-top">
      <ul className="nav nav-pills mb-4" role="tablist">
        <li className="nav-item">
          <button type="button" className="nav-link active" role="tab" data-bs-toggle="tab" data-bs-target="#navs-pills-overview" aria-controls="navs-pills-top-home" aria-selected="true">Overview</button>
        </li>
        {/* <li className="nav-item">
          <button type="button" className="nav-link" role="tab" data-bs-toggle="tab" data-bs-target="#navs-pills-invoices" aria-controls="navs-pills-top-profile" aria-selected="false">Invoices</button>
        </li> */}
        <li className="nav-item">
          <button type="button" className="nav-link" role="tab" data-bs-toggle="tab" data-bs-target="#navs-pills-company" aria-controls="navs-pills-company" aria-selected="false">Company Information</button>
        </li>
      </ul>
      <div className="tab-content">
        <div data-testid="instance-nodes-overview" className="tab-pane fade show active" id="navs-pills-overview" role="tabpanel">
          <Overview instance={instance} />
        </div>
        <div className="tab-pane fade" id="navs-pills-invoices" role="tabpanel">
          <Invoices />
        </div>
        <div className="tab-pane fade" id="navs-pills-company" role="tabpanel">
          <CompanyInformation instance={instance} />
        </div>
      </div>
    </div>
  );
}

interface Props {
  instance: Instance
}

export { InstanceNodes };
